import { shallowRef as I, watch as b, unref as v, onUnmounted as k, defineComponent as E, toRefs as R, ref as A, watchPostEffect as D, openBlock as h, createBlock as z, resolveDynamicComponent as j, withCtx as q, createElementVNode as x, renderSlot as B } from "vue";
import { OverlayScrollbars as y } from "overlayscrollbars";
const F = () => {
  if (typeof window > "u") {
    const o = () => {
    };
    return [o, o];
  }
  let a, t;
  const n = window, r = typeof n.requestIdleCallback == "function", l = n.requestAnimationFrame, s = n.cancelAnimationFrame, d = r ? n.requestIdleCallback : l, u = r ? n.cancelIdleCallback : s, e = () => {
    u(a), s(t);
  };
  return [
    (o, f) => {
      e(), a = d(
        r ? () => {
          e(), t = l(o);
        } : o,
        typeof f == "object" ? f : { timeout: 2233 }
      );
    },
    e
  ];
}, g = (a) => {
  let t = null, n, r, l;
  const s = I(a || {}), [d, u] = F();
  return b(
    () => {
      var e;
      return v((e = s.value) == null ? void 0 : e.defer);
    },
    (e) => {
      l = e;
    },
    { deep: !0, immediate: !0 }
  ), b(
    () => {
      var e;
      return v((e = s.value) == null ? void 0 : e.options);
    },
    (e) => {
      n = e, y.valid(t) && t.options(n || {}, !0);
    },
    { deep: !0, immediate: !0 }
  ), b(
    () => {
      var e;
      return v((e = s.value) == null ? void 0 : e.events);
    },
    (e) => {
      r = e, y.valid(t) && t.on(
        /* c8 ignore next */
        r || {},
        !0
      );
    },
    { deep: !0, immediate: !0 }
  ), k(() => {
    u(), t == null || t.destroy();
  }), [
    (e) => {
      if (y.valid(t))
        return t;
      const o = () => t = y(e, n || {}, r || {});
      l ? d(o, l) : o();
    },
    () => t
  ];
}, P = /* @__PURE__ */ E({
  __name: "OverlayScrollbarsComponent",
  props: {
    element: {
      type: String,
      default: "div"
    },
    options: { type: Object },
    events: { type: Object },
    defer: { type: [Boolean, Object] }
  },
  emits: ["osInitialized", "osUpdated", "osDestroyed", "osScroll"],
  setup(a, { expose: t, emit: n }) {
    const r = a, l = {
      initialized: "osInitialized",
      updated: "osUpdated",
      destroyed: "osDestroyed",
      scroll: "osScroll"
    }, { element: s, options: d, events: u, defer: e } = R(r), o = I(null), f = I(null), S = A(), [O, C] = g({ options: d, events: S, defer: e });
    return t({
      osInstance: C,
      getElement: () => o.value
    }), D((p) => {
      const { value: m } = o, { value: i } = f;
      m && i && (O({
        target: m,
        elements: {
          viewport: i,
          content: i
        }
      }), p(() => {
        var c;
        return (c = C()) == null ? void 0 : c.destroy();
      }));
    }), b(
      () => v(u),
      (p) => {
        const m = p || {};
        S.value = Object.keys(l).reduce((i, c) => {
          const w = m[c];
          return i[c] = [
            (..._) => n(
              l[c],
              ..._
            ),
            ...(Array.isArray(w) ? w : [w]).filter(Boolean)
          ], i;
        }, {});
      },
      { deep: !0, immediate: !0 }
    ), (p, m) => (h(), z(j(v(s)), {
      "data-overlayscrollbars-initialize": "",
      ref_key: "elementRef",
      ref: o
    }, {
      default: q(() => [
        x("div", {
          "data-overlayscrollbars-contents": "",
          ref_key: "slotRef",
          ref: f
        }, [
          B(p.$slots, "default")
        ], 512)
      ]),
      _: 3
    }, 512));
  }
});
export {
  P as OverlayScrollbarsComponent,
  g as useOverlayScrollbars
};
//# sourceMappingURL=overlayscrollbars-vue.mjs.map
